<script setup lang="ts">
import { computed } from 'vue';
import venues from '../images/tournament-headers/venues.json';

interface Venue {
    focus: string;
    width: number;
    author: string;
    license: string;
    licenseUrl: string | null;
    source: string;
}

interface Props {
    venue?: string;
    surface: string;
}
const props = defineProps<Props>();

const images = import.meta.glob<string>('../images/tournament-headers/*.webp', { eager: true, query: '?url', import: 'default' });

const venueData: Record<string, Venue> = venues;

// Venues without an own photo show a generic photo of their surface.
const imageKey = computed(() => {
    if (props.venue && images[`../images/tournament-headers/${props.venue}.webp`]) {
        return props.venue;
    }

    return `fallback-${props.surface}`;
});
const src = computed(() => images[`../images/tournament-headers/${imageKey.value}.webp`]);
const srcSmall = computed(() => images[`../images/tournament-headers/${imageKey.value}-800.webp`]);
const image = computed(() => venueData[imageKey.value]);
</script>

<template>
    <template v-if="src && image">
        <img :src="src" :srcset="srcSmall && image.width > 800 ? `${srcSmall} 800w, ${src} ${image.width}w` : undefined" sizes="100vw" alt="" class="absolute inset-0 size-full object-cover" :style="{ objectPosition: image.focus }">
        <div class="absolute inset-0 bg-linear-to-t from-black/70 via-black/20 to-transparent" />
        <div class="absolute inset-0 bg-linear-to-r from-black/40 to-transparent" />
        <div class="absolute right-2 bottom-1 text-[10px] text-white/70">
            <a :href="image.source" target="_blank" rel="noopener" class="hover:text-white">{{ image.author }}</a>,
            <a v-if="image.licenseUrl" :href="image.licenseUrl" target="_blank" rel="noopener" class="hover:text-white">{{ image.license }}</a>
            <span v-else>{{ image.license }}</span>
        </div>
    </template>
</template>
